import React, { useState } from 'react';
import { Modal, Form, Input, Typography, Button, message } from 'antd';
import { VinAllocation } from '../../screen/delivery/types/DeliveryTypes';
import TextArea from "antd/es/input/TextArea";
import { trimitraCatalogServices } from '../../services/trimitraCatalog/trimitraCatalogServices';
import { CopyOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface FormDeliveryProps {
    visible: boolean;
    onCancel: () => void;
    onSubmit: (values: any) => void;
    onSuccess?: () => void;
    vinData: VinAllocation | null;
}

interface BookingResponse {
    book_code: string;
    document_url: string;
}

const FormDelivery: React.FC<FormDeliveryProps> = ({
    visible,
    onCancel,
    onSubmit,
    onSuccess,
    vinData
}) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [successModalVisible, setSuccessModalVisible] = useState(false);
    const [bookingData, setBookingData] = useState<BookingResponse | null>(null);

    const handleSubmit = async () => {
        try {
            setLoading(true);
            const values = await form.validateFields();
            
            const formattedData = {
                company: "vinfast",
                vin_number: vinData?.vin_number || "",
                offer_code: values.offerCode || "",
                notes: values.notes || ""
            };

            const response = await trimitraCatalogServices.createProformaVinBooking(formattedData);
            
            if (response.data.success) {
                setBookingData(response.data.data);
                setSuccessModalVisible(true);
                onSubmit(formattedData);
                form.resetFields();
                onCancel(); // Tutup modal form
                onSuccess?.(); // Memanggil fetchVinAllocation untuk refresh data
            }
        } catch (error: any) {
            message.error(error.message || 'Terjadi kesalahan saat memproses booking');
        } finally {
            setLoading(false);
        }
    };

    const handleDownloadPDF = () => {
        if (bookingData?.document_url) {
            window.open(bookingData.document_url, '_blank');
        }
    };

    const handleCopyBookingCode = () => {
        if (bookingData?.book_code) {
            navigator.clipboard.writeText(bookingData.book_code)
                .then(() => {
                    message.success('Kode booking berhasil disalin');
                })
                .catch(() => {
                    message.error('Gagal menyalin kode booking');
                });
        }
    };

    return (
        <>
            <Modal
                title="Form Booking VIN"
                open={visible}
                onCancel={onCancel}
                onOk={handleSubmit}
                okText="Submit"
                cancelText="Batal"
                width={600}
                style={{ top: 20 }}
                bodyStyle={{ padding: '24px' }}
                confirmLoading={loading}
            >
                <div style={{ 
                    marginBottom: '32px',
                    padding: '16px',
                    background: '#f5f5f5',
                    borderRadius: '8px'
                }}>
                    <div style={{ marginBottom: '12px' }}>
                        <Text strong>VIN Number:</Text>
                        <Text style={{ marginLeft: '8px' }}>{vinData?.vin_number}</Text>
                    </div>
                    <div style={{ marginBottom: '12px' }}>
                        <Text strong>Model:</Text>
                        <Text style={{ marginLeft: '8px' }}>{vinData?.model_name}</Text>
                    </div>
                    <div style={{ marginBottom: '0' }}>
                        <Text strong>Warna:</Text>
                        <Text style={{ marginLeft: '8px' }}>{vinData?.color_name} ({vinData?.color_code})</Text>
                    </div>
                </div>

                <Form
                    form={form}
                    layout="vertical"
                    style={{ maxWidth: '100%' }}
                >
                    <Form.Item
                        name="offerCode"
                        label="Kode SPK"
                        rules={[
                            { required: true, message: 'Mohon masukkan kode SPK' }
                        ]}
                    >
                        <Input placeholder="Masukkan kode SPK" />
                    </Form.Item>

                    <Form.Item
                        name="notes"
                        label="Catatan"
                    >
                        <TextArea
                            placeholder="Masukkan catatan (opsional)"
                            showCount
                            maxLength={200}
                        />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="Booking Berhasil"
                open={successModalVisible}
                onCancel={() => setSuccessModalVisible(false)}
                footer={[
                    <Button key="close" onClick={() => setSuccessModalVisible(false)}>
                        Tutup
                    </Button>,
                    <Button key="download" type="primary" onClick={handleDownloadPDF}>
                        Download PDF
                    </Button>
                ]}
                width={400}
            >
                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    <Text strong style={{ fontSize: '16px', display: 'block', marginBottom: '16px' }}>
                        Nomor Booking:
                    </Text>
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px'
                    }}>
                        <Text style={{ fontSize: '20px', color: '#1890ff' }}>
                            {bookingData?.book_code}
                        </Text>
                        <CopyOutlined 
                            onClick={handleCopyBookingCode}
                            style={{ 
                                fontSize: '18px', 
                                color: '#1890ff',
                                cursor: 'pointer'
                            }}
                        />
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default FormDelivery; 